import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { useFetchData } from "hooks/apiHooks";
import useTextToSpeech from "hooks/useTextToSpeech";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { UserSettingsContext } from "contexts/UserSettingsContext";
import { faVolumeUp, faVolumeMute, faSpinner, faHand } from '@fortawesome/free-solid-svg-icons';
import TalkingAssistantAnimation from './TalkingAssistantAnimation';
import ApiError from "components/common/ApiError";
import { Circles } from 'react-loader-spinner';
import IconButtonWithTooltip from "components/buttons/IconButtonWithTooltip";
import FeedbackForm from "components/feedback/FeedbackForm";
import { API_ENDPOINTS } from "constants";

function AssistantProfileSpeaking({ text, feedbackContext }) {
    const { t } = useTranslation();
    const { speakOrMimik, isSpeaking, isSpeakActivated, toggleSpeakActivated, selectedVoiceURI} = useTextToSpeech()
    const { userSettings } = useContext(UserSettingsContext);
    const { data:activeAvatar, isLoading, error, refetch } = useFetchData(API_ENDPOINTS.AVATARS.ACTIVE);
    const [ showFeedbackInput, setShowFeedbackInput] = useState(false)

    useEffect(() => {
        if(userSettings?.is_assistant_talking){
            toggleSpeakActivated() 
        }
    }, [userSettings]); 

    useEffect(() => {
        if(isSpeakActivated && text && selectedVoiceURI){
            console.log('speak for embedded assistant')
            speakOrMimik(text)
        } 
    }, [text, isSpeakActivated]);

    if(error) return <ApiError retryFetch={refetch} errorMessage={error.message}/>
    if(isLoading) return <Circles color="var(--bs-purple-pizzazz)" ariaLabel="loading animation" wrapperStyle={{ display: "block" }} wrapperClass="mb-3" />;
  
    return (
        <>
            <div className="author">
                <div className="block block-one" />
                <div className="block block-two" />
                <div className="block block-three" />
                <div className="block block-four" />
                <a onClick={(e) => e.preventDefault()}>
                    <IconButtonWithTooltip translationId='assistant.feedback' icon={faHand} onClick={()=>{setShowFeedbackInput(!showFeedbackInput)}} type="IconOnly" size="sm"/>
                    <TalkingAssistantAnimation isReading={isSpeaking()} width={100} height={100} avatar={activeAvatar}/>
                    {isSpeaking() ? (
                        <span role="img" aria-label="speaker on">
                            <IconButtonWithTooltip translationId='assistant.stopTalking' icon={faVolumeUp} onClick={()=>toggleSpeakActivated()} type="IconOnly" size="sm"/>
                        </span>
                    ) : (
                        <span role="img" aria-label="speaker off">
                            <IconButtonWithTooltip translationId='assistant.talk' icon={faVolumeMute} onClick={()=>toggleSpeakActivated()} type="IconOnly" size="sm"/>
                        </span>
                    )}
                    <h5 className="title">
                        {isLoading ? 
                            <FontAwesomeIcon className="ml-3" icon={faSpinner} spin/> 
                        : 
                            activeAvatar?.name
                        }
                    </h5>
                    
                </a>
                <p className="description">{activeAvatar.title || t('assistant.title')}</p>
            </div>
            {showFeedbackInput && <FeedbackForm feedbackContext={feedbackContext}/>}
        </>
    )
}

export default AssistantProfileSpeaking;
